import { routes } from "@/global/routes";
import {
  DefaultCheckoutTerms,
  DefaultRegistrationTerms,
} from "../../default_terms_and_conditions";
import { vendorUUIDs } from "../../constants";
import { faqs, howItWorks, purchaseSeatsLanguages } from "./helpers";

import type { TeamConfig } from "../types";

import SeatMapImage from "public/images/aviators/SeatMap.png";
import AuthBgBanner from "public/images/aviators/aviators_bg.webp";
import LogoImage from "public/images/aviators/aviators_logo_jan_24.png";
import FindGamesBanner from "public/images/aviators/Aviators Choose Your Pack.jpg";
import SeatMap3dPreview from "public/images/aviators/aviators_seat_map_preview.png";

const config: TeamConfig = {
  teamSchema: "aviators_flexpack",
  browserTitle: "Aviators Preset Packs",
  packages: true,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "Las Vegas Aviators",

  // seat map configs
  seatMapConfigs: {
    venueId: "",
    mapId: "",
    staticSeatMapImage: SeatMapImage.src,
    isShowAvailableSeatsButtonHidden: true,
    isView3dButtonHidden: true,
    customSeatMapStaticImageStyle: {
      width: "63%",
      display: "block",
      marginX: "auto",
    },
  },

  dynamicPricingForPackages: {
    enabled: true,
    list: [
      {
        id: 1,
        updatedAccountGroup: 0,
      },
      {
        id: 2,
        updatedAccountGroup: 1,
      },
      {
        id: 3,
        updatedAccountGroup: 2,
      },
    ],
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.purchaseSeats,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [routes.giftCard],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: "SEAT-LEVEL",

  // purchase seat configs
  purchaseSeatConfigs: {
    minGameSelectionCount: 7,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: true,
    isCheckoutEditSeatsEnabled: true,
    isDiffSeatAlertEnabled: false,
    defaultSeatCount: 2,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: true,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
    cantSelectMoreGames: true,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  isSaveCardAllowed: true,

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/aviatorslv/",

  // images
  images: {
    logoNameImage: "",
    faviconImage: LogoImage.src,
    authBackgroundImage: AuthBgBanner.src,
    checkoutStatusPageImage: AuthBgBanner.src,
    findGamesBannerImage: FindGamesBanner.src,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
    logoImage: LogoImage.src + "?width=100&height=78",
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: true,
      hideOverlayLogo: true,
    },

    bottomBar: {
      showGameSelectionProgress: true,
    },
  },

  colors: {
    primary: "#022243",
  },

  howItWorks,
  faqs,

  languages: {
    topNavMenuItems: null,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: purchaseSeatsLanguages,
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutSuccessMessage: "Your purchase is complete!",
    checkoutSuccessDescription:
      "Your Las Vegas Aviators tickets are confirmed! Your tickets will be available shortly.",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
